/**
 * Breadcrumb Component
 * Renders navigation breadcrumbs + JSON-LD BreadcrumbList schema for Google.
 */

export interface Breadcrumb {
  label: string;
  href?: string; // No href = current page (last item)
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function renderBreadcrumbs(items: Breadcrumb[]): string {
  if (items.length <= 1) return '';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, i) => ({
      '@type': 'ListItem',
      'position': i + 1,
      'name': item.label,
      ...(item.href ? { 'item': `https://play.ecstaticoracle.dance${item.href}` } : {}),
    })),
  };

  const breadcrumbItems = items.map((item, i) => {
    const isLast = i === items.length - 1;
    if (isLast) {
      return `<li class="breadcrumb-item"><span class="breadcrumb-current" aria-current="page">${escapeHtml(item.label)}</span></li>`;
    }
    return `<li class="breadcrumb-item"><a href="${item.href}" class="breadcrumb-link">${escapeHtml(item.label)}</a><span class="breadcrumb-separator" aria-hidden="true">/</span></li>`;
  }).join('');

  return `
    <script type="application/ld+json">${JSON.stringify(jsonLd)}</script>
    <nav class="breadcrumbs" aria-label="Breadcrumb">
      <ol class="breadcrumb-list">
        ${breadcrumbItems}
      </ol>
    </nav>
  `;
}
